/* Loads Shopify product recommendations into the section once it nears the viewport. */

(() => {
  'use strict';

  class AntartiRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url) return;
      this.io = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this.io.disconnect();
          this.load();
        },
        { rootMargin: '400px 0px' }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      this.io?.disconnect();
    }

    async load() {
      try {
        const res = await fetch(this.dataset.url);
        if (!res.ok) return;
        const html = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = html.querySelector('antarti-recommendations');
        if (!fresh || !fresh.innerHTML.trim()) return;
        this.innerHTML = fresh.innerHTML;
        window.antarti?.motion?.reveal(this);
        document.dispatchEvent(new CustomEvent('antarti:recommendations', { detail: { section: this } }));
      } catch {
        /* nothing to show */
      }
    }
  }

  (window.antarti?.define || ((n, c) => customElements.get(n) || customElements.define(n, c)))('antarti-recommendations', AntartiRecommendations);
})();
